@if (isOpen()) {
  <div class="py-3 px-6 a-notification -{{ type() }} items-center" role="alert">
    @if (icon()) {
      <i class="a-icon {{ icon() }}"></i>
    }
    <div class="a-notification__content flex-grow ml-2 text-base">
      <ng-content />
    </div>
    <ng-content select=".notification-bar__actions" />
    @if (closable()) {
      <div class="cursor-pointer flex items-center justify-center" (click)="isOpen.set(false)">
        <i class="a-icon boschicon-bosch-ic-close text-[22px]"></i>
      </div>
    }
  </div>
}
